import { render, staticRenderFns } from "./order-message-file.vue?vue&type=template&id=2042f970"
import script from "./order-message-file.vue?vue&type=script&lang=js"
export * from "./order-message-file.vue?vue&type=script&lang=js"
import style0 from "./order-message-file.vue?vue&type=style&index=0&id=2042f970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports